var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayChart)?_c('active-engaged-chart',{staticClass:"ma-0 pt-5",attrs:{"data":_vm.activeEngagedData,"height":"100%","width":"100%"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }